module.exports = __webpack_public_path__ + "img/loginimage.fc026a93.png";